export var ServicesFieldTypes;
(function (ServicesFieldTypes) {
    ServicesFieldTypes["ServiceName"] = "service_name";
    ServicesFieldTypes["DB"] = "db_system";
    ServicesFieldTypes["MESSAGING"] = "messaging_system";
})(ServicesFieldTypes || (ServicesFieldTypes = {}));
export var OperationTypes;
(function (OperationTypes) {
    OperationTypes["Operation"] = "operation";
})(OperationTypes || (OperationTypes = {}));
export var EnvIdType;
(function (EnvIdType) {
    EnvIdType["EnvId"] = "env_id";
})(EnvIdType || (EnvIdType = {}));
//# sourceMappingURL=services-field-types.enum.js.map